import React, { useRef } from 'react';
import { getContext, useCombinedRefs } from 'common';
import Styled from './styles';

const HorizontalMoreButtonItemContext = React.createContext<any>({});

export interface HorizontalMoreButtonItemProps extends React.ComponentPropsWithRef<'div'> {
  /**  children, menu item content, consider using 'HorizontalMoreButtonItemIcon'. */
  children: React.ReactNode;
  /** To configure the size of the `MoreButton`. */
  size?: 'small' | 'medium';
}

/** HorizontalMoreButton menu item which supports icon.
 * Any other props will be provided to the wrapper element.
 */
const HorizontalMoreButtonItem = React.forwardRef<HTMLElement, HorizontalMoreButtonItemProps>((props: HorizontalMoreButtonItemProps, forwardedRef) => getContext(({ RTL }) => {
  const {
    children,
    size,
    ...otherProps
  } = props;
  const innerRef = useRef(null);
  const ref = useCombinedRefs(forwardedRef, innerRef);

  return (
    <Styled.MenuItem
      ref={ref}
      $rtl={RTL}
      tabIndex={-1}
      role="menuitem"
      onFocus={event => event.preventDefault()}
      {...otherProps}
    >
      <HorizontalMoreButtonItemContext.Provider value={{ size }}>
        {children}
      </HorizontalMoreButtonItemContext.Provider>
    </Styled.MenuItem>
  );
}));

HorizontalMoreButtonItem.displayName = 'HorizontalMoreButtonItem';

HorizontalMoreButtonItem.defaultProps = {
  size: 'medium'
};

export {
  HorizontalMoreButtonItem as default,
  HorizontalMoreButtonItemContext
};
